import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertIcon } from './icons';
import { Field } from './parts';

export const BUSINESS_KEYS = ['cafe', 'restaurant', 'fastfood', 'lounge', 'sweets', 'retail', 'other'];

/**
 * «نوع النشاط» — single required choice rendered as chips (radio inputs under a
 * fieldset, so keyboard + screen readers get native radio-group behaviour).
 * Choosing `other` reveals a required free-text field.
 *
 * ⚠ DESCRIPTIVE ONLY. This value goes to the signup endpoint as
 * business_category(+_other). It is NOT account_type and must never feed the
 * restaurant/standard switch.
 */
export default function BusinessTypeChips({ value, onChange, other, onOther, error, otherError }) {
  const { t } = useTranslation();
  const cats = t('authPage.signup.cats', { returnObjects: true });
  return (
    <fieldset className="ppa-cats" id="cat" aria-describedby="cat-e">
      <legend>{t('authPage.signup.cat')}</legend>
      <div className="ppa-cat-row">
        {cats.map(([k, label]) => (
          <label className="ppa-cat" key={k}>
            <input type="radio" name="cat" value={k} checked={value === k} onChange={() => onChange(k)} />
            <span>{label}</span>
          </label>
        ))}
      </div>
      <span className="ppa-err" id="cat-e" hidden={!error}>{error ? <><AlertIcon size={15} />{error}</> : null}</span>
      {value === 'other' && (
        <div className="ppa-cat-other">
          <Field
            id="catother" label={t('authPage.signup.catOther')} placeholder={t('authPage.signup.catOtherPh')}
            value={other} onChange={(e) => onOther(e.target.value)} error={otherError} autoComplete="off"
          />
        </div>
      )}
    </fieldset>
  );
}
